/** @format */

import React from "react";
import "./About.css";
import { tagsList } from "./List";

const About = () => {
  return (
    <section className='section-first'>
      <div className='box grid h-full text-lg grid-cols-2 p1 md:grid-cols-3 align-middle'>
        {tagsList.map((e, index) => (
          <p key={index} className='text-center grid place-content-center'>{e}</p>
        ))}
      </div>
      <span className='absolute -top-[60px]' id='about'></span>
    </section>
  );
};

export default About;
